// extracted by mini-css-extract-plugin
module.exports = {"root":"Image_root__vazPv","caption":"Image_caption__4g389"};